<div class="">
    <!-- <table> -->
      <div style="display: flex;">
        <span>Basic Filters:</span>
        <!-- <mat-form-field *ngFor="let filter of filterSelectObj" style="margin-left: 15px;" appearance="outline">
          <mat-label> {{filter.name}}</mat-label>
          <select matNativeControl name="{{filter.columnProp}}" (change)="filterChange(filter,$event)">
            <option value="">{{filter.name}}: All {{filter.name}}</option>
            <option [value]="item" *ngFor="let item of filter.options  | orderBy: filter.columnProp ">{{item}}</option>
          </select>
        </mat-form-field> -->
        <div class="" style="margin-left: 15px; margin-top: 10px; border-radius: 48px; height: 35px; width: 200px; margin-bottom: 20px;">
          <select class="form-control" (change)="vesselFilter($event)">
            <option value="">Vessel: All Vessel</option>
            <option *ngFor="let option of dropName;" [value]="option.Ship">
             {{option.Ship}}
            </option>
          </select>
      </div>
      <div class="" style="margin-left: 15px; margin-top: 10px; border-radius: 48px; height: 35px; width: 200px; margin-bottom: 20px;">
        <select class="form-control"  (change)="operatorFilter($event)">
          <option value="">Operator: All Operator</option>
          <option *ngFor="let option of dropName | uniqFilter:'master_operator'" [value]="option.master_operator">
           {{option.master_operator}}
          </option>
        </select>
    </div>
        <div class="" style="margin-left: 15px; margin-top: 10px; border-radius: 48px; height: 35px; width: 200px; margin-bottom: 20px;">
          <select class="form-control" [formControl]="DWTFilterControl" (change)="dwtFilter($event)">
            <option value="">DWT: All DWT</option>
            <option *ngFor="let option of DWTFilter" [value]="option">
             {{option}}
            </option>
          </select>
      </div>
      <div class="" style="margin-left: 15px; margin-top: 10px; border-radius: 48px; height: 35px; width: 200px; margin-bottom: 20px;">
          <select class="form-control" (change)="ageFilter($event)">
            <option value="">Age: All Age</option>
            <option *ngFor="let option of AgeFilter" [value]="option">
             {{option}}
            </option>
          </select>
      </div>
        <!-- &nbsp; -->
        <!-- <button mat-flat-button color="primary" (click)="downloadFile($event)">Download</button> -->
        <!-- <button mat-raised-button color="primary"
        style="border-radius: 50px; width: fit-content; height: 48px; border: 1px solid #008ECF; padding: 8px, 16px, 8px, 16px; background-color: #008ECF; margin-left: 8px;"
        (click)="downloadFile($event)" >
        Download Report</button> -->
      </div>
      
    <table mat-table [dataSource]="User" class="mat-elevation-z8" matSort (matSortChange)="announceSortChange($event)">
      <ng-container matColumnDef="Ship">
        <th mat-header-cell *matHeaderCellDef mat-sort-header style="width: 80px;" sortActionDescription="Sort by name"> Vessel </th>
        <td mat-cell *matCellDef="let element" style="width: 150px; height: 16px;"> {{element.Ship}} </td>
      </ng-container>
      <ng-container matColumnDef="master_operator">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Operator </th>
        <td mat-cell *matCellDef="let element" style="color: #27364B; width: 200px; height: 16px;"> {{element.master_operator}} </td>
      </ng-container>
      <ng-container matColumnDef="ship_type">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Tank Type </th>
        <td mat-cell *matCellDef="let element" style="width: 120px;"> {{element.tank_type}} </td>
      </ng-container>
      <ng-container matColumnDef="DWT">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> DWT </th>
        <td mat-cell *matCellDef="let element"> {{element.DWT | number}} </td>
      </ng-container>
      <ng-container matColumnDef="age">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Age </th>
        <td mat-cell *matCellDef="let element"> {{element.age}} </td>
      </ng-container>
      <ng-container matColumnDef="eta_time">
        <th mat-header-cell *matHeaderCellDef mat-sort-header style="width: 120px;"> ETA </th>
        <td mat-cell *matCellDef="let element"> {{element.eta_time | date:'dd/MM/yyyy'}} </td>
      </ng-container>
      <ng-container matColumnDef="Tanks">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Tanks </th>
        <td mat-cell *matCellDef="let element"> {{element.Tanks}} </td>
      </ng-container>
      <ng-container matColumnDef="destination">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Next Port (AIS) </th>
        <td mat-cell *matCellDef="let element"> {{element.destination}} </td>
      </ng-container>
      <ng-container matColumnDef="stop_port_UNlocode">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Last Port </th>
        <td mat-cell *matCellDef="let element"> {{element.stop_port_name | titlecase}}, {{element.stop_port_UNlocode.slice(0,2)  | uppercase}} </td>
      </ng-container>
      <ng-container matColumnDef="probability">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Confidence</th>
        <td mat-cell *matCellDef="let element"> {{element.probability | number : '1.0-0' }}% </td>
      </ng-container>
      
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="getRecord(row)"></tr>
    </table>
    <mat-paginator #paginator [pageSizeOptions]="[5, 10, 20]"
                 showFirstLastButtons 
                 aria-label="Select page of User">
  </mat-paginator>
  </div>